#import "./SecureRowLevelsEntityFields.graphql"
query SupplierSecureRowLevels {
  secureRowLevels(orderBy: SECURITY_LEVEL_ASC) {
    nodes {
      ...SecureRowLevelsEntityFields
    }
  }
}
